import { getMemberTypewiseSectionConfig } from "../api/memberTypewiseSectionConfig.hooks";
import { useParams } from "react-router-dom";
import Form from "./Form";
import FormLoader from "components/Containers/FormLoader";

export default function Page() {
  const { memberTypewiseSectionConfigID } = useParams();

  const getQuery = getMemberTypewiseSectionConfig(
    memberTypewiseSectionConfigID
  );

  return getQuery.isFetching && memberTypewiseSectionConfigID !== undefined ? (
    <FormLoader />
  ) : (
    <>
      <Form memberTypewiseSectionConfig={getQuery.data?.apiData} />
    </>
  );
}
